import React, { useEffect, useRef, useState } from 'react';
import Form, {
    ButtonItem,
    SimpleItem,
    GroupItem,
    Label,
    EmailRule,
    RequiredRule,
    AsyncRule,
    
} from 'devextreme-react/form';
import { dataAccess, editorOptionsNumberBox, editorOptionsSwitch, resources } from '../../data/app';
import useAuthorization from '../../hooks/useAuthorization';
import { Button, NumberBox, Switch, TextBox, Validator } from 'devextreme-react';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { useSelector,useDispatch } from 'react-redux';
import { setAppInfo } from '../../store/app/appActions';
import { DivFormColumns } from '../../components/form/DivForm';

const AppConfig = () => {

    const { authorized } = useAuthorization([resources.app, dataAccess.access ]);
    const [saving, setSaving] = useState({
        loading : false,
        text : 'Guardar'
    });

    const dispatch = useDispatch();
    const { appInfo } = useSelector(store => store); 
    
    const [app, setApp] = useState({...appInfo});
    const refForm = useRef();

    const onValueChanged = (e) => {
        setApp({...app, checkSmsDaysNotify: e.value});
    }

    const onFormSubmit = (e) => {

        e.preventDefault();

        setSaving({loading : true, text:'Guardando...'});
        http('about/set-info').asPost(app).then(resp => {

            notify('Datos actualizados');
            setSaving({loading : false, text:'Guardar'});
            dispatch(setAppInfo(app));
            
        }).catch(err => {

            notify(err, 'error');
            setSaving({loading : false, text:'Guardar'});

        });
    }

    useEffect(() => {
        setApp({...app, ...appInfo});
    }, [appInfo]);   

    return authorized(
        <div className="container small">
            <form onSubmit={onFormSubmit}>
                <div className="dx-fieldset">
                    <div className="dx-fieldset-header">Configuracion de productos</div>
                    <DivFormColumns title='% de utilidad'
                        description="Ingrese el % de ganancia para cada producto">                        
                        <NumberBox     
                            step={0.01}                       
                            format="#0%" 
                            value={app.profitPercent}                           
                            onValueChanged={e => setApp(app => ({ ...app, profitPercent: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <div className="dx-fieldset-header">Configuracion de factura</div>
                    <DivFormColumns title='Inicio de factura'
                        description="Ingrese el rango de factura">                        
                        <NumberBox                            
                            value={app.numberBillFrom}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberBillFrom: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Fin del rando de factura'
                        description="Ingrese el rango de factura">                        
                        <NumberBox                            
                            value={app.numberBillTo}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberBillTo: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Alerta'
                        description="Ingrese el stock para generar alertas, deje en 0 sino quiere alertas">                        
                        <NumberBox                            
                            value={app.numberBillDiff}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberBillDiff: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Dias de credito'
                        description="Ingrese el numero de dias de credito para las facturas al credito">                        
                        <NumberBox                            
                            value={app.creditLimit}                           
                            onValueChanged={e => setApp(app => ({ ...app, creditLimit: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Vigencias'
                        description="Ingrese el numero de dias de valides de una proforma">                        
                        <NumberBox                            
                            value={app.quoteExpirationDays}                           
                            onValueChanged={e => setApp(app => ({ ...app, quoteExpirationDays: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Filas en la factura'
                        description="Ingrese el numero de filas en la factura">                        
                        <NumberBox                            
                            value={app.rowsByBill}                           
                            onValueChanged={e => setApp(app => ({ ...app, rowsByBill: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio de venta opcion 1'
                        description="Espeficique el % de descuento para la opcion 1">                        
                        <NumberBox        
                            step={0.01}         
                            format="#0%"                    
                            value={app.pvt1}                           
                            onValueChanged={e => setApp(app => ({ ...app, pvt1: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio de venta opcion 2'
                        description="Espeficique el % de descuento para la opcion 2">                        
                        <NumberBox       
                            step={0.01}         
                            format="#0%"                     
                            value={app.pvt2}                           
                            onValueChanged={e => setApp(app => ({ ...app, pvt2: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Precio de venta opcion 3'
                        description="Espeficique el % de descuento para la opcion 3">                        
                        <NumberBox      
                            step={0.01}          
                            format="#0%"                     
                            value={app.pvt3}                           
                            onValueChanged={e => setApp(app => ({ ...app, pvt3: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <div className="dx-fieldset-header">Configuracion de Recibos</div>
                    <DivFormColumns title='Inicio de recibos'
                        description="Ingrese el rango de recibos">                        
                        <NumberBox                            
                            value={app.numberReceiptFrom}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberReceiptFrom: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Fin del rando de recibos'
                        description="Ingrese el rango de recibos">                        
                        <NumberBox                            
                            value={app.numberReceiptTo}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberReceiptTo: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Alerta de recibos'
                        description="Ingrese el stock para generar alertas de recibos, deje en 0 sino quiere alertas">                        
                        <NumberBox                            
                            value={app.numberReceiptDiff}                           
                            onValueChanged={e => setApp(app => ({ ...app, numberReceiptDiff: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <div className="dx-fieldset-header">Configuracion de agenda</div>
                    <DivFormColumns title='Notificacion de citas'
                        description="Notificar via sms a los clientes su cita programada">                        
                        <Switch style={{ float : "left" }}                        
                            value={app.checkSmsDaysNotify}                           
                            onValueChanged={e => setApp(app => ({ ...app, checkSmsDaysNotify: e.value }))}     
                            {...editorOptionsSwitch}                      
                        >                            
                        </Switch>
                    </DivFormColumns>
                    <DivFormColumns title='Dias de anticipacion'
                        description="Dias anticipados que se enviara la notificacion al cliente">                        
                        <NumberBox                            
                            value={app.smsDaysNotify}                           
                            onValueChanged={e => setApp(app => ({ ...app, smsDaysNotify: e.value }))}
                            {...editorOptionsNumberBox}
                            disabled={!app.checkSmsDaysNotify}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Intervalor para cita (min)'
                        description="Duracion de cada cita en minutos">                        
                        <NumberBox                            
                            value={app.intervalAppoinment}                           
                            onValueChanged={e => setApp(app => ({ ...app, intervalAppoinment: e.value }))}
                            {...editorOptionsNumberBox}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Ancho de relleno en identificación de Cliente'
                        description="Ancho de relleno en identificación de Cliente. Ej: si su valor es 5 para el id de cliente 1 se mostrara 00001 ">                        
                        <NumberBox                            
                            value={app.customerPadding}                           
                            onValueChanged={e => setApp(app => ({ ...app, customerPadding: e.value }))}
                            {...editorOptionsNumberBox}
                            min={0}
                            max={7}
                        >
                            <Validator>
                                <RequiredRule message="Este campo es requerido" />
                            </Validator>
                        </NumberBox>
                    </DivFormColumns>
                    <div className="dx-fieldset-header">Configuracion de sistema</div>
                    <DivFormColumns title='Duraccion de la sessión (min)'
                        description="La session se cerrar automaticamente cuando transcurra el tiempo especificado">                        
                        <NumberBox                        
                            value={app.sessionTime}                           
                            onValueChanged={e => setApp(app => ({ ...app, sessionTime: e.value }))}     
                            {...editorOptionsNumberBox}                      
                        >                            
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Factor de doble autenticación activado'
                        description="Notificar via sms al usuario administrador un token para incio de sesion(factor de doble autenticación)">                        
                        <Switch style={{ float : "left" }}                        
                            value={app.twoFactorAuthEnabled}                           
                            onValueChanged={e => setApp(app => ({ ...app, twoFactorAuthEnabled: e.value }))}     
                            {...editorOptionsSwitch}                      
                        >                            
                        </Switch>
                    </DivFormColumns>
                    <DivFormColumns title='Habilitar notificacion de Stock minimo de productos'
                        description="El sistema notificara via correo los productos que ya estan en el stock minimo">                        
                        <Switch style={{ float : "left" }}                        
                            value={app.warnMinStock}                           
                            onValueChanged={e => setApp(app => ({ ...app, warnMinStock: e.value, warnMinStockEmail: e.value ? app.warnMinStockEmail:''}))}     
                            {...editorOptionsSwitch}                      
                        >                            
                        </Switch>
                    </DivFormColumns>
                    <DivFormColumns title='Ingrese los correos a los que se enviara la notificacion de stock minimo'
                        description="Detalle los correos a los que se le enviara la notificacion, separe por (,) si necesita mas de uno">                        
                        <TextBox
                            readOnly={!app.warnMinStock}                      
                            value={app.warnMinStockEmail}                           
                            onValueChanged={e => setApp(app => ({ ...app, warnMinStockEmail: e.value }))}     
                            {...editorOptionsSwitch}   
                            placeholder="example@email.com"                   
                        >                            
                        </TextBox>
                    </DivFormColumns>
                    <div className="dx-fieldset-header">Configuracion de SMS</div>
                    <DivFormColumns title='Aviso de mensajes restantes'
                        description="Notificar via sms cuando esten por agotarse los sms, recordar recargar">                        
                        <NumberBox                         
                            value={app.smsRemaining}                           
                            onValueChanged={e => setApp(app => ({ ...app, smsRemaining: e.value }))}     
                            {...editorOptionsNumberBox}                     
                        >                            
                        </NumberBox>
                    </DivFormColumns>
                    <DivFormColumns title='Contacto de aviso de mensajes restantes'
                        description="Notificar a este numero cuando esten por agotarse los sms">                        
                        <TextBox                         
                            value={app.smsPhoneNotifyRemaining}                           
                            onValueChanged={e => setApp(app => ({ ...app, smsPhoneNotifyRemaining: e.value }))}     
                            {...{mask: '(999) 9999-9999'}}                     
                        >                            
                        </TextBox>
                    </DivFormColumns>
                </div>
                <Button 
                    icon='save'
                    text={saving.text} 
                    disabled={saving.loading}
                    type="default"                     
                    useSubmitBehavior={true}>
                </Button>
            </form>           
        </div>
    );
}

export default AppConfig;
